import { useState } from "react";
import { Skeleton, useTheme } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  mediaString,
  eventPhotosSubtitleString,
  galleryLoadIssueString,
  viewItHereString,
} from "../../constants";
import { useAppSelector } from "../../app/hooks";
import { selectLanguage } from "../../app/slices/languageSlice";

const externalGalleryUrl = "https://bethelbibleoc.pixieset.com/";

function Gallery() {
  const language = useAppSelector(selectLanguage);
  const theme = useTheme();
  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <div
      style={{
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        paddingTop: "var(--nav-height)",
        backgroundColor: theme.palette.background.default,
        fontFamily: theme.typography.fontFamily,
        overflow: "hidden",
      }}
    >
      <div style={{ flexShrink: 0, maxWidth: "1100px", width: "100%", margin: "0 auto", padding: "24px 24px 12px" }}>
        <h1
          style={{
            fontFamily: theme.typography.secondaryFontFamily,
            fontSize: "min(8vw, 36px)",
            fontWeight: 600,
            color: theme.palette.primary.dark,
            margin: "0 0 8px",
          }}
        >
          {mediaString(language)}
        </h1>
        <p
          style={{
            fontFamily: theme.typography.paragraphFontFamily,
            fontSize: "14px",
            lineHeight: 1.5,
            color: theme.palette.text.secondary,
            margin: 0,
            maxWidth: "620px",
          }}
        >
          {eventPhotosSubtitleString(language)}
        </p>
      </div>

      {/* This box - and the Pixieset page inside it - is the only thing
          that scrolls. The outer page is locked to one viewport height so
          we never end up with two nested scrollbars fighting each other. */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          maxWidth: "1100px",
          width: "100%",
          margin: "0 auto",
          padding: "0 24px 12px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            position: "relative",
            flex: 1,
            minHeight: 0,
            border: `1px solid ${theme.palette.brand.border}`,
            borderRadius: "10px",
            overflow: "hidden",
            backgroundColor: theme.palette.brand.linen,
          }}
        >
          {!iframeLoaded && (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{ position: "absolute", top: 0, left: 0, bgcolor: theme.palette.brand.mist }}
            />
          )}
          <iframe
            src={externalGalleryUrl}
            title="Bethel Bible Church photo gallery"
            loading="lazy"
            onLoad={() => setIframeLoaded(true)}
            style={{ position: "relative", width: "100%", height: "100%", border: "none" }}
          />
        </div>

        <div
          style={{
            flexShrink: 0,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "5px",
            padding: "8px 0",
            fontFamily: theme.typography.paragraphFontFamily,
            fontSize: "11px",
            color: theme.palette.text.secondary,
          }}
        >
          <span>{galleryLoadIssueString(language)}</span>
          <a
            href={externalGalleryUrl}
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "3px",
              fontFamily: theme.typography.fontFamily,
              fontWeight: 600,
              color: theme.palette.primary.main,
              textDecoration: "none",
            }}
          >
            {viewItHereString(language)}
            <OpenInNewIcon sx={{ fontSize: "12px" }} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
